// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"48a158be","239":"36242b22","455":"c5eeed57"}[chunkId] + ".chunk.js";
};